import { EventAvailableSlot } from 'api-clients/monolith';

import analyticsEvents from './analyticsEvents';

export interface splitOption {
  label: string;
  value: number;
}

export interface CreateEventProps {
  scrollParent?: HTMLDivElement | null;
  event: EventAvailableSlot;
  isUpdate?: boolean;
}

export interface FooterProps {
  isUpdatingEvent: boolean;
  isSaveButtonEnabled: boolean;
  resetForm: (valueOverrides?: Partial<EventAvailableSlot> | undefined) => void;
  onSubmit: (mode: UpdateModeType) => void;
  redirectToCalendar: (eventDate?: string) => void;
  availableSlot: EventAvailableSlot;
  runValidations: () => boolean;
}

export const UpdateModeTypes = {
  UNBOOKED: 'unbooked',
  ALL: 'all',
  SINGLE: 'single',
} as const;

export type UpdateModeType =
  (typeof UpdateModeTypes)[keyof typeof UpdateModeTypes];

export type AnalyticsEventType =
  (typeof analyticsEvents)[keyof typeof analyticsEvents];
